import React from 'react';
import Utils from '../../Api/Utils';

function formatPrice(price_cents) {
  let price_dollars = Utils.formatCents(price_cents);

  let cents = price_dollars.substr(-2);
  let whole = price_dollars.substr(0, price_dollars.length - 3);

  return (
    <span className="price">
        <span className="sign">$</span>
        <span className="dollars">{whole}</span>
        <span className="dot">.</span>
        <span className="cents">{cents}</span>
      </span>
  );
}

function findWithToken(arr, token) {
  return arr.find(item => { return(item && item.token === token); });
}

export {
  formatPrice,
  findWithToken
};


/** WEBPACK FOOTER **
 ** ./src/components/Cart/tools.js
 **/